export default __webpack_public_path__ + "static/media/step5-4.72f789e4.png";